import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';

export type OptionItem = {
    label: string;
    svg: string;
    arrowIcon: boolean;
    new: boolean;
    disabled: boolean;
    subOptionItem?: {
        label: string;
        svg: string;
        arrowIcon: boolean;
        disabled: boolean;
    }[];
};

@Component({
    selector: 'app-mimic-option-dialog',
    templateUrl: './mimic-option-dialog.component.html',
    styleUrls: ['./mimic-option-dialog.component.css'],
    standalone: false,
})
export class MimicOptionDialogComponent {
    @ViewChild('dialog') dialogElement: ElementRef;

    selectedOptionItem: OptionItem;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            optionItemList: OptionItem[];
        },
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<MimicOptionDialogComponent>
    ) {}

    async selectOption(optionItem: OptionItem, event: MouseEvent) {
        const rect = this.dialogElement.nativeElement.getBoundingClientRect();

        if (!optionItem.arrowIcon) {
            this.dialogRef.close(optionItem);
        } else if (optionItem.subOptionItem) {
            const currentTargetRect = (event.currentTarget as HTMLElement).getBoundingClientRect();
            const dialogRef = this.dialog.open(MimicOptionDialogComponent, {
                data: {
                    optionItemList: optionItem.subOptionItem,
                },
                backdropClass: 'transparent-backdrop',
                position: {
                    top: `${currentTargetRect.top + 5}px`,
                    left: `${rect.x + rect.width + 5}px`,
                },
                disableClose: false,
            });

            this.selectedOptionItem = optionItem;

            const selectedOptionItem = await lastValueFrom(dialogRef.afterClosed());

            if (selectedOptionItem) {
                this.dialogRef.close(selectedOptionItem);
            }
        }

        this.selectedOptionItem = null;
    }
}
